import type { DomainManifest } from 'modules/core/lib/manifests/types'
import type { Navigation, NavigationPaths } from 'modules/core/lib/navigation/context'

import { ArchiveSurveyActivity } from 'modules/engagement_surveys/activities/ArchiveSurvey'
import { CreateSurveyActivity } from 'modules/engagement_surveys/activities/CreateSurvey'
import { DeleteSurveyActivity } from 'modules/engagement_surveys/activities/DeleteSurvey'
import { DuplicateSurveyActivity } from 'modules/engagement_surveys/activities/DuplicateSurvey'
import { FinishSurveyActivity } from 'modules/engagement_surveys/activities/FinishSurvey'
import { PublishSurveyActivity } from 'modules/engagement_surveys/activities/PublishSurvey'
import { RemindRespondentsActivity } from 'modules/engagement_surveys/activities/RemindRespondents'

export const manifest = {
  sidebar: (_navigation: Navigation<NavigationPaths>) => ({
    items: [],
  }),
  activities: {
    duplicateSurvey: {
      component: DuplicateSurveyActivity,
    },
    deleteSurvey: {
      component: DeleteSurveyActivity,
    },
    createSurvey: {
      component: CreateSurveyActivity,
    },
    archiveSurvey: {
      component: ArchiveSurveyActivity,
    },
    finishSurvey: {
      component: FinishSurveyActivity,
    },
    publishSurvey: {
      component: PublishSurveyActivity,
    },
    remindRespondents: {
      component: RemindRespondentsActivity,
    },
  },
} as const satisfies DomainManifest
